// extracted by mini-css-extract-plugin
export var calendarView = "_ng-0";
export var dayButton = "_ng-1";
export var dayCircle = "_ng-2";